export enum GeneratedFileStatusModel {
	New = 1,
	Generating = 2,
	Completed = 3,
	Failed = 4
}
